import React, { useState } from 'react';
import defaultHead from "./images/defaultHead.png"
import "./style.less";

interface AvatarProps {
    className?: string,
    style?: object,
    width: string,
    url: string,
}

export default function Avatar(textProps: AvatarProps) {

    const { className = "", style = {}, width = "100px", url = defaultHead } = textProps;

    let [error, setError] = useState(false);
    const onError = () => {
    };

    let props: any = {
        className: "com-avatar " + className,
        style: {
            ...style,
            width,
            height: width,
            minWidth: width,
            minHeight: width,
        }
    }

    return (
        <div {...props}>
            <img src={(!error && url) || defaultHead} onError={onError} alt="" />
        </div>
    )
}